import { useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from './Sidebar';
import Header from './Header';

interface AppShellProps {
  children: React.ReactNode;
}

const SIDEBAR_WIDTH = 180;
const SIDEBAR_COLLAPSED_WIDTH = 56;
const HEADER_HEIGHT = 64;

export default function AppShell({ children }: AppShellProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);

  const currentSidebarWidth = sidebarCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        width={currentSidebarWidth}
        isMobile={isMobile}
        collapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          ml: isMobile ? 0 : `${currentSidebarWidth}px`,
          transition: 'margin 0.2s ease',
        }}
      >
        <Header
          height={HEADER_HEIGHT}
          onMenuClick={() => isMobile ? setSidebarOpen(!sidebarOpen) : setSidebarCollapsed(!sidebarCollapsed)}
          showMenuButton={true}
          sidebarWidth={isMobile ? 0 : currentSidebarWidth}
        />

        <Box
          component="main"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            px: 2,
            pt: 1.5,
            pb: 0.5,
            mt: `${HEADER_HEIGHT}px`,
            backgroundColor: 'background.default',
            overflow: 'auto',
            height: `calc(100vh - ${HEADER_HEIGHT}px)`,
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}
